import Vue from "vue";
let currentRequest = 0;

const UserRoleService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("role", id, {});
      return data.data[0];
    } catch (error) {
      console.log("fetchOne error: ", error);
      return { error: error };
    }
  },
  async fetchAll() {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START USER_ROLE`);
      const res = await Vue.$jsonApi.findAll("roles");
      if (request !== currentRequest) {
        console.log(`[${request}] USER_ROLE DISCARDED`);
        return null;
      }
      console.log(`[${request}] END USER_ROLE`);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  }
};

export { UserRoleService };
